<template>
  <div class="entry-main">
    <ButtonBack class="mb_m"/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-created-at">
          申請日
        </div>

        <div class="table-header-user-id">
          ユーザー名
        </div>

        <div class="table-header-allowed">
          参加
        </div>
      </div>

      <div
        v-for="(entry, index) in entries"
        :key="index"
        class="table-cell"
        >

        <div class="table-cell-created-at">
          {{ $store.getters['date/createdAt'](entry) }}
        </div>

        <div class="table-cell-user-id">
          <link-edit-user :model="entry" />
        </div>

        <div class="table-cell-allowed">
          {{ entry.get('allowed').get('ja') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ButtonBack from '@/components/ButtonBack'
import LinkEditUser from '@/components/User/LinkEditUser'
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [
    MixinResultHandler
  ],

  components: {
    ButtonBack,
    LinkEditUser
  },

  computed: {
    ...mapState('entryClosed', [
      'entries'
    ])
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-created-at {
    padding: 5px;
    width: 10%;
  }

  &-user-id {
    padding: 5px;
    width: 65%;
  }

  &-allowed {
    padding: 5px;
    width: 10%;
  }
}

@import '@/styles/_table.scss';
@import '@/styles/_icon.scss';
</style>
